import HorizontalFoldingSlider from "components/horizontalFoldingSlider/HorizontalFoldingSlider";
import { Typography } from "design_system/src";
import React from "react";
import HeadquarterItem, { HeadquarterItemProps } from "./HeadquarterItem";


const headquartersItems: HeadquarterItemProps[] = [
  {
    title: "Sede Anáhuac",
    subtitle: "Oficina principal",
    address: "Laguna de Mayran 396, Anáhuac I Secc., Anáhuac I Secc, Miguel Hidalgo, 11320 Ciudad de México, CDMX, México.",
    googleMapsLink: "https://maps.app.goo.gl/hWWWDqwB8d58h3ih7",
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/conoce_nuestras_sedes_anahuac_financiamiento_facil_small",
    desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_financiamiento_facil",
    dekstopLineUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_financiamiento_facil_linea_1",
    imageAlt: "Oficina principal de Ozon en Ciudad de México",
  },
  {
    title: "Bodega de Remates y",
    subtitle: "Taller de mecánica",
    address: "Calle Lago Chiem 114A, colonia Reforma Pensil, en la Ciudad de México.",
    googleMapsLink: "https://maps.app.goo.gl/kP8R4Q8X2Qhb1QVF7",
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/conoce_nuestras_sedes_cedis_financiamiento_facil_small",
    desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_cedis_financiamiento_facil",
    dekstopLineUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_financiamiento_facil_linea_2",
    imageAlt: "Bodega de Remates y taller de mecánica de Ozon en Ciudad de México",
  },
];

const Headquarters: React.FC = () => {
  const headquartersSectionRef = React.useRef<HTMLDivElement>(null);
  return (
    <section className="dso_container p_y_md">
      <Typography scale="heading1" scaleMobile="heading3" weight="600" component="h2">Conoce nuestras sedes</Typography>

      <HorizontalFoldingSlider
        name="Headquarters"
        data={headquartersItems.map((item) => <HeadquarterItem {...item} />)}
        sectionRef={headquartersSectionRef}
      />
    </section>
  );
};

export default Headquarters;
